/** Échéances fiscales et sociales Gabon (CGI 2026, CNSS, CNAMGS, AUSCG). */
export interface EcheanceFiscaleGabon {
  jour: number;
  mois_recurrent?: 'mensuel';
  mois?: number;
  code: string;
  label: string;
  source: string;
}

export const ECHEANCES_FISCALES_GABON: readonly EcheanceFiscaleGabon[] = [
  {
    jour: 20,
    mois_recurrent: 'mensuel',
    code: 'TVA',
    label: 'Déclaration et paiement TVA (et CSS) du mois précédent',
    source: 'CGI Art. 237 ; https://dgi.ga/imposition-des-personnes-morales/taxes-sur-le-chiffre-daffaires/tva/',
  },
  {
    jour: 20,
    mois_recurrent: 'mensuel',
    code: 'CNSS',
    label: 'Cotisations CNSS du mois écoulé',
    source: 'Code Sécurité Sociale',
  },
  {
    jour: 20,
    mois_recurrent: 'mensuel',
    code: 'CNAMGS',
    label: 'Cotisations CNAMGS du mois écoulé',
    source: 'Loi 028/2007',
  },
  {
    jour: 15,
    mois_recurrent: 'mensuel',
    code: 'IRPP',
    label: 'Retenues sur salaires : IRPP, TCS, FNH (DAMS)',
    source: 'CGI Art. 95-96 et 350 ; https://dgi.ga/particuliers/regles-de-determination-de-la-tcs/',
  },
  {
    jour: 30,
    mois: 11,
    code: 'ISA-1',
    label: '1er acompte IS (un quart de l’IS de l’année précédente)',
    source: 'CGI 2025 Art. 21',
  },
  {
    jour: 30,
    mois: 1,
    code: 'ISA-2',
    label: '2e acompte IS (un tiers de l’IS de l’année précédente)',
    source: 'CGI 2025 Art. 21',
  },
  {
    jour: 30,
    mois: 4,
    code: 'MD2D',
    label: 'Déclaration annuelle IS / MD2D et paiement du solde',
    source: 'CGI 2025 Art. 20 et 21',
  },
  {
    jour: 30,
    mois: 4,
    code: 'DAS1',
    label: 'DAS 1 — Déclaration annuelle salaires',
    source: 'CGI Art. 100',
  },
  {
    jour: 30,
    mois: 4,
    code: 'DAS2',
    label: 'DAS 2 — Honoraires non-salariés',
    source: 'CGI Art. 100',
  },
  {
    jour: 30,
    mois: 4,
    code: 'BIC',
    label: 'BIC — Bénéfices industriels commerciaux',
    source: 'CGI',
  },
  {
    jour: 31,
    mois: 1,
    code: 'PATENTE',
    label: 'Patente professionnelle annuelle',
    source: 'CGI Art. 280',
  },
  {
    jour: 30,
    mois: 6,
    code: 'AG-ORD',
    label: 'Assemblée générale ordinaire (dans 6 mois clôture)',
    source: 'AUSCG Art. 348',
  },
];
